import React, { useEffect } from 'react';
import '../Dashboard/dashboard.scss';
import './focusedForm.scss'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import DashboardFooter from '../../components/Footer/DashboardFooter';
import withFeatureFlags from '../../components/FeatureFlags/withFeatureFlags'
import SiteDown from '../../components/SiteDown/SiteDown';
import OutOfHours from '../../components/LiveChat/OutOfHours';
import ChatDownTime from '../../components/LiveChat/ChatDownTime';
import { joinClasses } from '../../utils/helpers';
import {useUnifiedAnalytics} from "../../contexts/AnalyticsWrapper";

/** @import { FocusedFormProps } from './FocusedFormTypes' */

const FocusedForm = (/** @type {FocusedFormProps} */ { children, className, featureEnabled, pageAnalyticsName }) => {
    const analytics = useUnifiedAnalytics();

    useEffect(() => {
        const analyticsPageName = pageAnalyticsName || 'Maturity Instruction Form';
        analytics.trackAnalyticsPageEvent('generic load',{},'',`Investec-Save-secure|page_load|${analyticsPageName}`);
    }, [pageAnalyticsName]);

    if (featureEnabled("DashboardOffline")) {
        return (
            <SiteDown />
        );
    }
    return (
        <div className={joinClasses('dashboard-layout', className || '')}>
            <div className='dashboard-content'>
                <Breadcrumbs withBg />
                <div className='focused-form-layout__content' style={{maxWidth:"1800px"}}>
                    {children}
                </div>
            </div>
            <DashboardFooter />
            <OutOfHours />
            <ChatDownTime />
        </div>
    );
};

export default withFeatureFlags(FocusedForm);

